import { NextSeo } from 'next-seo'
import { Header } from '@components/Header'
import { Footer } from '@components/Footer'

export default function Terms() {
  return (
    <>
      <NextSeo title="Privacy Policy" description="Majordomo Privacy Policy" />
      <Header />

      <main className="pt-8 px-0 container mx-auto">
        <div className="max-w-5xl mx-auto">
          <div className="space-y-8 pt-12 md:pb-36 pb-12">
            <h4 className="font-black">Majordomo Privacy Policy</h4>
            <p>
              <h4 className="font-black">Effective Date:</h4> September 1, 2020
            </p>
            <p>
              <h4 className="font-black">Last Updated Date:</h4> September 1,
              2020
            </p>
            <p>
              Majordomo LLC (“Majordomo,” “we,” “our,” or “us”), respects your
              privacy and is committed to maintaining and using your information
              responsibly. Accordingly, Majordomo has developed this ‎Privacy
              Policy in order for you to understand how Majordomo collects,
              uses, discloses, and otherwise processes your personal
              information. This Privacy Policy describes our information and
              privacy practices that apply when you use our website located at{' '}
              <a
                className="text-accentBlue font-black hover:underline"
                href="https://www.majordomo.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                www.majordomo.com
              </a>
              , the Majordomo mobile application, as well as through other
              electronic means as may be applicable from time to time
              (collectively, the “Site”). ‎ This Privacy Policy covers your use
              of the Site, including when you access, ‎enter information into,
              and/or use any services or other ‎features that we may offer
              through the Site. The foregoing activities are collectively
              referred to as your “use of” ‎the Site (or a similar phrase), or
              the “Activities”.
            </p>
            <p>
              PLEASE READ this Privacy Policy before using the Site. By using
              the Site, you signify to us that you have read and understand the
              data practices described in this statement, and that you
              understand that this privacy policy may be updated from
              time-to-time to take into account changes in law, technology, and
              our operations. We will post any changes to ‎this Privacy Policy
              on the Site and, where appropriate, notify ‎you by e-mail. You can
              determine if this Privacy Policy has been revised since last
              accessing ‎the Site by referring to the effective date or last
              updated date at the top of this Privacy Policy. Please
              periodically review this Privacy Policy before using the Site, as
              your ‎continued use of the Site indicates to us your
              acknowledgment and understanding of any ‎changes. All personal
              information held by us will be governed by the most recent Privacy
              Policy posted across the Site. If we intend to use
              earlier-collected Personal Information ‎and
              Automatically-Collected Information in accordance with the terms
              of the revised Privacy ‎Policy and doing so would result in a use
              for a different purpose than stated at the time of ‎collection,
              where required by law we will request your express consent prior
              to such use
            </p>
            <h4 className="font-black">
              Collection of your Personal Information
            </h4>
            <p>
              In order to better provide you with products and services offered
              on our Site, Majordomo may collect personally identifiable
              information, such as, but not limited to your:
            </p>
            <p>
              Personal Information Provided by You. We collect first name,
              maiden name, last name, and nickname; phone numbers; email
              addresses; social media; purchase history; financial information
              (credit card number, purchase history, invoices); passwords; and
              other similar data. At times we may also collect data about you
              from publicly available sources, which may include personal
              information such as your: first name, maiden name, last name, and
              nickname; phone numbers; email addresses; social media; and other
              similar data.
            </p>
            <p>
              Payment Data. We collect data necessary to process your payment if
              you make purchases through your use of the Site, such as your
              payment instrument number (such as a credit card number), and the
              security code associated with your payment instrument. All payment
              data is stored by{' '}
              <a
                className="text-accentBlue font-black hover:underline"
                href="https://www.stripe.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://www.stripe.com
              </a>
              . You may find their privacy policy link(s) here:{' '}
              <a
                className="text-accentBlue font-black hover:underline"
                href="https://stripe.com/privacy"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://stripe.com/privacy.
              </a>
            </p>
            <p>
              All personal information that you provide to us must be true,
              complete and accurate, and you must notify us of any changes to
              such personal information.
            </p>
            <p>
              If you purchase Majordomo's products and services, we collect
              billing and credit card information. This information is used to
              complete the purchase transaction.
            </p>
            <p>
              Majordomo may also collect anonymous demographic information,
              which is not unique to you.
            </p>
            <p>
              Please keep in mind that if you directly disclose personally
              identifiable information or personally sensitive data through
              Majordomo's public message boards, this information may be
              collected and used by others.
            </p>
            <p>
              You may be required to provide certain personal information to us
              when you elect to use certain products or services available on
              the Site. These may include: (a) registering for an account on our
              Site; (b) entering a sweepstakes or contest sponsored by us or one
              of our partners; (c) signing up for special offers from selected
              third parties; (d) sending us an email message; (e) submitting
              your credit card or other payment information when ordering an
              purchasing products and services on our Site; (f) claiming a
              property as your own; (g) use of Majordomo Contacts; (h) use of
              Majordomo Concierge; (i) providing a home inspection(s) and/or
              quotes; (k) providing any other home information. To wit, we will
              use your information for, but not limited to, communicating with
              you and/or other professionals services/service providers provided
              within Majordomo.com in relation to services and/or products you
              have requested from us. We also may gather additional personal or
              non-personal information in the future.
            </p>
            <h4 className="font-black">Information you Provide</h4>
            <p>
              When using the Site and our services, you may provide details and
              information about yourself and your properties. Information
              provided about a property (specific address) by you, or by your
              Professional at your authorization will become part of the
              permanent record for the home. The information will be private to
              you during your ownership and your home/account unless you choose
              to share it. All information that is added to the home’s address
              is deemed permanent data to be associated with that address.
            </p>
            <p>
              Majordomo reserves the right to remove or update any user or
              Professional provided information based on Majordomo's terms of
              use agreement, Domoscore/Domoreport user’s rules and agreement,
              professional user’s agreement, Majordomo Contacts and Concierge
              agreement and our Privacy Policy.
            </p>
            <h4 className="font-black">Information automatically collected</h4>
            <p>
              Some information — such as IP address and/or browser and device
              characteristics — is collected automatically when you visit the
              Site.
            </p>
            <p>
              We automatically collect certain information when you visit, use
              or navigate the Site. This information does not reveal your
              specific identity (like your name or contact information) but may
              include device and usage information, such as your IP address,
              browser and device characteristics, operating system, language
              preferences, referring URLs, device name, country, location,
              information about how and when you use the Siteand other technical
              information. This information is primarily needed to maintain the
              security and operation of the Site, and for our internal analytics
              and reporting purposes.
            </p>
            <p>
              Like many businesses, we also collect information through cookies
              and similar technologies.
            </p>
            <p>
              Online Identifiers. We collect tools and protocols, such as IP
              (Internet Protocol) addresses; cookie identifiers, or others such
              as the ones used for analytics and marketing; device's
              geolocation; devices; applications; and other similar data.
            </p>
            <p>
              Majordomo uses data collected by cookies and javascript libraries
              to improve your browsing experience, analyze site traffic, deliver
              personalized recommendations and marketing content, and increase
              the overall performance of our site. Most browsers automatically
              accept cookies, but you can disable the acceptance of cookies at
              any time by changing the preferences in your browser. Most
              browsers also allow you to change the settings to require that the
              browser notify you when you receive a new cookie. Please refer to
              your browser for information on how to disable and control
              cookies. Information about managing cookies in commonly used
              browsers is available online from{' '}
              <a
                className="text-accentBlue font-black hover:underline"
                href="https://www.allaboutcookies.org"
                target="_blank"
                rel="noopener noreferrer"
              >
                www.allaboutcookies.org
              </a>
              . If you disable your web browser’s ability to accept cookies, you
              will be able to access the Services, but you may not be able to
              successfully use certain features of the Services.
            </p>
            <h4 className="font-black">Tracking User Behavior</h4>
            <p>
              Majordomo may keep track of the websites and pages our users visit
              within Majordomo using general internet analytics, to determine
              what Majordomo services are the most popular. This data is used to
              deliver customized content and advertising within Majordomo to
              customers whose behavior indicates that they are interested in a
              particular subject area.
            </p>
            <p>
              Majordomo and its affiliates, including software from other
              companies incorporated into Majordomo’s website may be tracking
              certain user data from within Majordomo’s site. These services may
              include, but not be limited to:
            </p>
            <p>
              Oracle.com,{' '}
              <a
                className="text-accentBlue font-black hover:underline"
                href="https://www.oracle.com/legal/terms.html"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://www.oracle.com/legal/terms.html
              </a>
            </p>
            <p>
              Google Analytics,{' '}
              <a
                className="text-accentBlue font-black hover:underline"
                href="https://www.google.com/analytics/terms/us.html"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://www.google.com/analytics/terms/us.html
              </a>
            </p>
            <p>
              Facebook,{' '}
              <a
                className="text-accentBlue font-black hover:underline"
                href="https://www.facebook.com/customaudiences/app/tos/?ref=u2u"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://www.facebook.com/customaudiences/app/tos/?ref=u2u
              </a>
            </p>
            <p>
              Intercom.com,{' '}
              <a
                className="text-accentBlue font-black hover:underline"
                href="om, https://www.intercom.com/terms-and-policies#terms"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://www.intercom.com/terms-and-policies#terms
              </a>
            </p>
            <p>
              Segment.com,{' '}
              <a
                className="text-accentBlue font-black hover:underline"
                href="https://segment.com/legal/terms/"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://segment.com/legal/terms/
              </a>
            </p>
            <p>
              Fullstory.com,{' '}
              <a
                className="text-accentBlue font-black hover:underline"
                href="om, https://www.fullstory.com/legal/terms-and-conditions/"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://www.fullstory.com/legal/terms-and-conditions/
              </a>
            </p>
            <p>
              Stripe.com,{' '}
              <a
                className="text-accentBlue font-black hover:underline"
                href="https://stripe.com/privacy"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://stripe.com/privacy
              </a>
            </p>
            <p>
              Users are responsible for reviewing any and all privacy policies
              of these associated companies to their satisfaction to their
              satisfaction. To check your system for tracking data and to
              exercise controls, users can visit{' '}
              <a
                className="text-accentBlue font-black hover:underline"
                href="https://www.aboutads.info/choices"
                target="_blank"
                rel="noopener noreferrer"
              >
                www.aboutads.info/choices
              </a>
              .
            </p>
            <p>
              Information about your computer hardware and software may be
              automatically collected by Majordomo. This information can
              include: your IP address, browser type, domain names, access times
              and referring website addresses. This information is used for the
              operation of the service, to maintain quality of the service, and
              to provide general statistics regarding use of the Majordomo
              website.
            </p>
            <h4 className="font-black">Our use of Google Analytics</h4>
            <a
              className="text-accentBlue font-black hover:underline"
              href="https://policies.google.com/technologies/partner-sites"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://policies.google.com/technologies/partner-sites
            </a>
            <p>
              When you access the Site, Google Analytics may automatically
              collect ‎information ‎from you through the use of Google’s
              analytics IDs, and Google provides some of this ‎information to us
              in aggregate and anonymized form. An analytics ID is a specific
              string of numbers and letters (often ‎called a “character string”)
              that is assigned to your computer or device but does not ‎name
              you. The analytics ID allows Google to track usage data of a
              website or mobile app, such as ‎date and time of visit, duration
              of visit, website traffic patterns, “clickstreams,” other ‎similar
              ‎information about how visitors use a website, ‎the type of web
              browser used, the ‎operating ‎system/platform a visitor uses, IP
              address, the ‎websites that referred or ‎linked a user to a
              ‎website, and your CPU speed.‎ Google Analytics provides
              information ‎about the use of our Site to us in aggregate form
              (i.e., data about many ‎users combined and not just about you).
              Some of this data might include the regional ‎location or city of
              users, but again, this data will be in aggregate (and not
              individual) ‎form. Google Analytics also provides data
              anonymization features which Majordomo enables for its use of
              Google Analytics across the Site. We might use information we
              receive from Google Analytics to learn how users ‎are using the ‎
              Site in general, and to improve the Site. We will not receive the
              analytics ID ‎assigned to your computer or device that you use to
              access and use the Site.‎
            </p>
            <h4 className="font-black">GOOGLE MAPS</h4>
            <p>
              We use Google Maps for the purpose of providing better service.
            </p>
            <p>
              The Site uses Google Maps APIs. You may find the Google Maps APIs
              Terms of Service here. To better understand Google’s Privacy
              Policy, please refer to this link.
            </p>
            <p>
              By using our Maps API Implementation, you agree to be bound by
              Google’s Terms of Service. You agree to allow us to obtain or
              cache your location. You may revoke your consent at any time. We
              use information about location in conjunction with data from other
              data providers.
            </p>
            <h4 className="font-black">
              Information collected through our Apps
            </h4>
            <p>
              We may collect information regarding your geo-location, mobile
              device, push notifications, when you use our apps.
            </p>
            <p>
              If you use our Apps, we may also collect the following
              information:
            </p>
            <ul>
              <li>
                Geo-Location Information. We may request access or permission to
                and track location-based information from your mobile device,
                either continuously or while you are using our mobile
                application, to provide location-based services. If you wish to
                change our access or permissions, you may do so in your device's
                settings.
              </li>

              <li>
                Mobile Device Access. We may request access or permission to
                certain features from your mobile device, including your mobile
                device's camera, and other features. If you wish to change our
                access or permissions, you may do so in your device's settings.
              </li>

              <li>
                Mobile Device Data. We may automatically collect device
                information (such as your mobile device ID, model and
                manufacturer), operating system, version information and IP
                address.
              </li>

              <li>
                Push Notifications. We may request to send you push
                notifications regarding your account or the mobile application.
                If you wish to opt-out from receiving these types of
                communications, you may turn them off in your device's settings.
              </li>
            </ul>
            <h4 className="font-black">Our Business Model</h4>
            <p>
              Majordomo services are generally funded by, but not limited to,
              users purchasing Majordomo product offerings, advertising and
              membership services of users and professional recommendations. The
              revenue from these services helps make Majordomo relevant, and
              continually innovative, while being available to use by our
              general users for their personal purposes. We work diligently to
              make our programs, subscriptions and advertisements interesting,
              useful and relevant to you based on the information you provide in
              relation to your use of our services. Majordomo uses the
              information you voluntarily provide about you and your home to
              build a relationship with you, communicate with you and provide
              our services - which include, but are not limited to presenting
              you with advertising, ideas, suggestions, and recommendations we
              believe may interest you and/or help you make more confident home
              decisions.
            </p>
            <p>
              Information about your property has been gathered and collected
              from you through your inspections and data input along with public
              resources like, but not limited to, county assessors, city data
              files, and similar public records sources. In addition, data
              points about your property may have also been gathered from
              private data warehouse services.
            </p>
            <h4 className="font-black">How We Use Your Personal Information</h4>
            <p>
              Majordomo collects and uses your personal information to operate
              the Site and deliver the services you have requested. Majordomo
              may also use your personally identifiable information and home
              information to inform you of other products or services available
              from Majordomo and its affiliates, though in such case Majordomo
              does not share your personal information with any of its
              third-party affiliates. Rather, Majordomo will provide you with
              information about how to contact such third-party affiliates if
              you are interested in their products or services.
            </p>
            <h4 className="font-black">To Provide the Site and our Services</h4>
            <p>
              If you are a user of Majordomo, we use your personal information:
            </p>
            <h4 className="font-black">Summary</h4>
            <ul>
              <li>
                To operate, maintain, administer and improve the Site and our
                services;
              </li>
              <li>
                To manage and communicate with you regarding your account, if
                you have one, including by sending you Site announcements,
                technical notices, updates, security alerts, and support and
                administrative messages;
              </li>
              <li>To process payments you make through the Site;</li>
              <li>
                To better understand your needs and interests, and personalize
                your experience with the Site; and
              </li>
              <li>
                to respond to your Site-related requests, questions and
                feedback.
              </li>
            </ul>
            <h4 className="font-black">Additional Details</h4>
            <ul className="list-disc list-outside px-8 space-y-4">
              <li>
                To facilitate account creation and logon process. If you choose
                to link your account with us to a third party account (such as
                your Google or Facebook account), we use the information you
                allowed us to collect from those third parties to facilitate
                account creation and logon process for the performance of the
                contract.
              </li>
              <li>
                To send you marketing and promotional communications. We may use
                the personal information you send to us for our marketing
                purposes, or to send you information from and/or about our
                third-party marketing partners, if this is in accordance with
                your marketing preferences. You can opt-out of our marketing
                emails at any time by using in app or Site features or
                contacting us at hello@majordomo.com. You can also unsubscribe
                from our marketing email list at any time by clicking on the
                unsubscribe link in the emails that we send or by contacting us
                using the address provided above. You will then be removed from
                the marketing email list – however, we will still need to send
                you service-related emails that are necessary for the
                administration and use of your account.
              </li>
              <li>
                To send administrative information to you. We may use your
                personal information to send you product, service and new
                feature information and/or information about changes to our
                terms, conditions, and policies.
              </li>
              <li>
                Fulfill and manage your orders. We may use your information to
                fulfill and manage your orders, payments, returns, and exchanges
                made through the Site or Apps.
              </li>
              <li>
                To post testimonials. We post testimonials on our Site or Apps
                that may contain personal information. Prior to posting a
                testimonial, we will obtain your consent to use your name and
                testimonial. If you wish to update, or delete your testimonial,
                please contact us at hello@majordomo.com and be sure to include
                your name, testimonial location, and contact information.
              </li>
              <li>
                Deliver targeted advertising to you. We may use your information
                to develop and display content and advertising (and work with
                third parties who do so) tailored to your interests and/or
                location and to measure its effectiveness. In such case we do
                not share your personal information with third parties for their
                marketing purposes.
              </li>
              <li>
                Administer prize draws and competitions. We may use your
                information to administer prize draws and competitions when you
                elect to participate in competitions.
              </li>
              <li>
                Request Feedback. We may use your information to request
                feedback and to contact you about your use of our Site or Apps.
              </li>
              <li>
                To protect our Site. We may use your information as part of our
                efforts to keep our Site or Apps safe and secure (for example,
                for fraud monitoring and prevention).
              </li>
              <li>
                To enable user-to-user communications. We may use your
                information in order to enable user-to-user communications with
                each user's consent.
              </li>
              <li>
                To enforce our terms, conditions and policies for business
                purposes, legal reasons and contractual.
              </li>
              <li>
                To respond to legal requests and prevent harm. If we receive a
                subpoena or other legal request, we may need to inspect the data
                we hold to determine how to respond.
              </li>
              <li>
                To manage user accounts. We may use your information for the
                purposes of managing your account and keeping it in working
                order.
              </li>
              <li>
                To deliver services to the user. We may use your information to
                provide you with the requested service.
              </li>
              <li>
                To respond to user inquiries/offer support to users. We may use
                your information to respond to your inquiries and solve any
                potential issues you might have with the use of our Site.
              </li>
              <li>
                For other business purposes. We may use your information for
                other business purposes, such as data analysis, identifying
                usage trends, determining the effectiveness of our promotional
                campaigns and to evaluate and improve our Site or Apps,
                products, marketing and your experience. We use and store this
                information in aggregated and anonymized form so that it is not
                associated with individual end users and does not include
                personal information.
              </li>
              <li>
                To communicate with you if you request information from us,
                register through the Site or participate in our surveys,
                promotions or events, we may send you Majordomo-related
                marketing communications but will provide you with the ability
                to opt out.
              </li>
              <li>
                To comply with law, we use your personal information as we
                believe necessary or appropriate to comply with applicable laws,
                lawful requests and legal process, such as to respond to
                subpoenas or requests from government authorities. We may use or
                share your personal information when you post a testimonials or
                endorsements on our Site, you instruct us to take a specific
                action with respect to your personal information or you sign up
                for a mailing list or to receive third party marketing
                communications.
              </li>
              <li>
                From time-to-time, for analytics purposes we may create
                anonymous data from your personal information and other
                individuals whose personal information we collect. We make
                personal information into anonymous data by excluding
                information that makes the data personally identifiable to you
                and use that anonymous data for our lawful business purposes.
              </li>
              <li>
                For compliance, fraud prevention and safety we use your personal
                information as we believe necessary or appropriate to (a)
                enforce the terms and conditions that govern the Site; (b)
                protect our rights, privacy, safety or property, and/or that of
                you or others; and (c) protect, investigate and deter against
                fraudulent, harmful, unauthorized, unethical or illegal
                activity.
              </li>
            </ul>
            <h4 className="font-black">
              Sharing Information with Third Parties
            </h4>
            <p>
              Majordomo sincerely appreciates your use of and contributions to
              the Site. Majordomo respects you and our relationships and does
              not sell, rent or lease its user or customer lists to third
              parties.
            </p>
            <p>
              Majordomo may, from time to time, contact you on behalf of
              third-party business partners about a particular offering that may
              be of interest to you. In those cases, as noted above, your unique
              personally identifiable information (e-mail, name, address,
              telephone number) is not transferred to the third party. Majordomo
              may share data with trusted partners to help perform statistical
              analysis, send you email or postal mail, provide customer support,
              or arrange for deliveries. All such third parties are prohibited
              from using your personal information except to provide these
              services to Majordomo, and they are required to maintain the
              confidentiality of your information.
            </p>
            <p>
              Majordomo provides services to help you connect with service and
              product professionals. Majordomo is in no way a party to your
              relationship with those professionals. Majordomo is not a licensed
              real estate/mortgage/insurance broker, brokerage or licensed
              contractor/home inspector. If you use the system to connect with
              such professionals, you are willingly providing those
              professionals information to help you build a relationship and
              make decisions. For the avoidance of doubt, Majordomo does not
              provide your personal information to third-party service and
              product professionals. For more information about finding and
              hiring professionals please review:
            </p>
            <p>
              <a
                className="text-accentBlue font-black hover:underline"
                href="http://help.majordomo.com/en/articles/3300612-what-should-i-know-about-researching-contractors-quick-tips"
                target="_blank"
                rel="noopener noreferrer"
              >
                QUICK TIPS FOR HIRING HOME PROFESSIONALS
              </a>
            </p>
            <p>
              <a
                className="text-accentBlue font-black hover:underline"
                href="http://help.majordomo.com/en/articles/3300628-hiring-home-professionals-and-contractor-research-tips"
                target="_blank"
                rel="noopener noreferrer"
              >
                INFORMATION ABOUT HIRING HOME PROFESSIONALS
              </a>
            </p>
            <p>
              Majordomo may share your personal information as needed to satisfy
              any requirements of the law and/or enforceable governmental
              request; to investigate violations to our terms of use; detect and
              prevent fraud and security issues; support compliance requirements
              protect the safety, health and rights of Majordomo LLC, its users
              and the public from harm.
            </p>
            <p>
              Majordomo may disclose your personal information with your
              consent. Examples include if you request information from a
              professional associated with Majordomo, third parties or
              advertisers. When Majordomo hires contractors to help provide our
              services, with your permission, we may give them access to your
              information only as needed and subject to the terms of this
              privacy agreement.
            </p>
            <p>
              Majordomo may share all your information if Majordomo is involved
              in a merger, acquisition, reorganization, restructuring, or other
              sale or transfer of all or any portion of its assets or business,
              whether as a going concern or as part of bankruptcy, liquidation,
              or similar proceedings in which information of users is among the
              assets transferred. In this event, we will, if allowed, use
              reasonable efforts to notify you when your personal information is
              transferred to any third party under this paragraph by posting
              such notice on the Site or by contacting you via the personal
              information you have provided us, if any. Unless you consent
              otherwise, we will require the third party to agree to only use
              your personal information in accordance with this Privacy Policy,
              even after the transfer. But any new information you provide after
              the transfer will likely be subject to a new policy, and you
              should review that policy.
            </p>
            <h4 className="font-black">Links</h4>
            <p>
              This website contains links to other sites. Please be aware that
              we are not responsible for the content or privacy practices of
              such other sites. We encourage our users to be aware when they
              leave our site and to read the privacy statements of any other
              site that collects personally identifiable information.
            </p>
            <h4 className="font-black">
              Security of your Personal Information
            </h4>
            <p>
              Majordomo secures your personal information from unauthorized
              access, use, or disclosure. Majordomo uses the following methods
              for this purpose:
            </p>
            <ul>
              <li>SSL Protocol</li>
            </ul>
            <p>
              When personal information (such as a credit card number) is
              transmitted to other websites, it is protected through the use of
              encryption, such as the Secure Sockets Layer (SSL) protocol.
            </p>
            <p>
              We strive to take appropriate security measures to protect against
              unauthorized access to or alteration of your personal information.
              Unfortunately, no data transmission over the Internet or any
              wireless network can be guaranteed to be 100% secure. As a result,
              while we strive to protect your personal information, you
              acknowledge that: (a) there are security and privacy limitations
              inherent to the Internet which are beyond our control; and (b)
              security, integrity, and privacy of any and all information and
              data exchanged between you and us through this Site cannot be
              guaranteed.
            </p>
            <h4 className="font-black">MINORS</h4>
            <p>
              If you are under the age of 18, you must ask your parent or
              guardian for permission to use this website. We do not knowingly
              solicit data from or market to children under 18 years of age. By
              using the Site or Apps, you represent that you are at least 18 or
              that you are the parent or guardian of such a minor and consent to
              such minor dependent’s use of the Site or Apps. If we learn that
              personal information from users less than 18 years of age has been
              collected, we will deactivate the account and take reasonable
              measures to promptly delete such data from our records. If you
              become aware of any data we have collected from children under age
              18, please contact us at hello@majordomo.com.
            </p>
            <h4 className="font-black">Communications</h4>
            <p>
              From time to time, Majordomo may contact you via email, or via
              other communication tools, for the purpose of providing
              announcements, promotional offers, alerts, confirmations, surveys,
              connections with home professionals and contractors, and/or other
              general communications in general. In order to improve our
              services, we may receive a notification when you open an email or
              other communication from Majordomo or click on a link therein.
            </p>
            <p>
              If you would like to stop receiving marketing or promotional
              communications via from Majordomo, you may opt out of such
              communications by clicking on unsubscribe or using other
              unsubscribe or discontinuing service functions within the site.
            </p>
            <h4 className="font-black">External Data Storage Sites</h4>
            <p>
              We may store your data on servers provided by third party hosting
              vendors with whom we have contracted.
            </p>
            <h4 className="font-black">YOUR CALIFORNIA PRIVACY RIGHTS</h4>
            <p>
              California Civil Code Section 1798.83, also known as the “Shine
              The Light” law, permits our users who are California residents to
              request and obtain from us, once a year and free of charge,
              information about categories of personal information (if any) we
              disclosed to third parties for direct marketing purposes and the
              names and addresses of all third parties with which we shared
              personal information in the immediately preceding calendar year.
              If you are a California resident and would like to make such a
              request, please submit your request in writing to us using the
              contact information provided below. For the avoidance of doubt,
              and as indicated above, we do not disclose personal information to
              third parties for their direct marketing purposes.
            </p>
            <p>
              If you are under 18 years of age, reside in California, and have a
              registered account with the Services or Apps, you have the right
              to request removal of unwanted data that you publicly post on the
              Services or Apps. To request removal of such data, please contact
              us using the contact information provided below, and include the
              email address associated with your account and a statement that
              you reside in California. We will make sure the data is not
              publicly displayed on the Services or Apps, but please be aware
              that the data may not be completely or comprehensively removed
              from our systems.
            </p>
            <h4 className="font-black">HOW LONG WE KEEP YOUR INFORMATION</h4>
            <p>
              We will only keep your personal information for as long as it is
              necessary for the purposes set out in this Privacy Policy, unless
              a longer retention period is required or permitted by law (such as
              tax, accounting or other legal requirements). No purpose in this
              policy will require us keeping your personal information for
              longer than the period of time in which users have an account with
              us.
            </p>
            <p>
              When we have no ongoing legitimate business need to process your
              personal information, we will either delete or anonymize it, or,
              if this is not possible (for example, because your personal
              information has been stored in backup archives), then we will
              securely store your personal information and isolate it from any
              further processing until deletion is possible.
            </p>
            <p>
              If you would at any time like to review or change the information
              in your account or terminate your account, you can:
            </p>
            <p>Log into your account settings and update your user account.</p>
            <p>
              Upon your request to terminate your account, we will deactivate or
              delete your account and information from our active databases.
              However, some information may be retained in our files to prevent
              fraud, troubleshoot problems, assist with any investigations,
              enforce our Terms of Use and/or comply with legal requirements.
            </p>
            Contact Information
            <p>
              Majordomo welcomes your questions or comments regarding this
              Statement of Privacy. If you believe that Majordomo has not
              adhered to this Statement, please contact Majordomo at:
            </p>
            <p>
              Majordomo LLC
              <br />
              5060 SW Philomath Blvd. Box 169
              <br />
              Corvallis, Oregon 97333
              <br />
              Email Address:
              <br />
              <a
                className="text-accentBlue font-black hover:underline"
                href="mailto:hello@majordomo.com"
              >
                hello@majordomo.com
              </a>
              <br />
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </>
  )
}
